export class SevalistforBooking {
    id: number;
    quantity : number;
    amount: number;
}



// WEBPACK FOOTER //
// ./src/models/SevalistforBooking.ts